import axios from 'axios';
import { DOMAIN, API_V1 } from '@/common/agent/ApiAgent';

export const URL_PATH_REFRESH = '/users/refresh';
export type RefreshResponseData = {
  access_token: string;
  token_type: string;
  access_token_expires_at: string;
};
const refresh = () => {
  return axios.post<RefreshResponseData>(DOMAIN + API_V1 + URL_PATH_REFRESH, undefined, {
    withCredentials: true,
  });
};

export default refresh;
